export default "__VITE_ASSET__ClBScJWg__"